import {gql} from '@apollo/client';
import {LibrarySongComplete} from '../../../../../../graphql/LibrarySongCompleteFragment';

export const LIBRARY_SONGS_QUERY = gql`
  query librarySongs($limit: Int, $offset: Int) {
    me {
      id
      library {
        songs(limit: $limit, offset: $offset) {
          ...LibrarySongComplete
        }
      }
    }
  }
  ${LibrarySongComplete.librarySong}
`;
